// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"f493a210","357":"4fdc8b10","363":"09b322ae","431":"ede8251a","636":"c59f1bfb","683":"98a77382","713":"b5ad63c1","721":"c0fbf68d","847":"f5f05617","859":"7423ea04","871":"0ce13254"}[chunkId] + ".chunk.js";
};